import type { Components, Theme } from '@mui/material';

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: () => ({
      fontSize: '1.4rem',
      padding: '0',
    }),
  },
};
